import React, { useState, useEffect, useRef } from "react";
import Avatar from "../../Images/avatar.png";
import SendIcon from "../../Images/send.svg";
import AttachIcon from "../../Images/attach.svg";
import { marked } from "marked";
import useWebSocket, { ReadyState } from "react-use-websocket";
import "./styles.css";
import { MAIN_URL } from "../../constants";
import axios from "axios";
import { toast } from "react-toastify";
import { CheckCircle2 } from "lucide-react";
import { Button, Card } from "../ui";
import ComplaintStatus from "./ComplaintStatus";

const TextRenderer = ({ text, className }) => {
    const formattedText = text.replace(/\n/g, "<br />");
    const htmlText = marked(formattedText);

    return (
        <div className={className} dangerouslySetInnerHTML={{ __html: htmlText }} />
    );
};

const Chat = ({ socket, user }) => {
    const TOKEN = localStorage.getItem("admin_token")    

    const reviewComplaint = () => {
        axios.post(`${MAIN_URL}/management/complaints/reviewed`, {
            complaint_type: 'student',
            complaint_id: user?.id
        }, {
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${TOKEN}`
            }
        }).then(response => {
            console.log(response.data);
            toast.success("Corrected Complaint")
        }).catch(error => {
            console.error(error);
        });
    }


    const sender = user?.user || user?.mentor;
    const senderName = [sender?.first_name, sender?.last_name].filter(Boolean).join(' ');

    return (
        <Card className="ui-complaint-detail" padding="none">
            <div className="ui-complaint-detail__head">
                <div className="ui-complaint-detail__meta">
                    {senderName && <span className="ui-complaint-detail__sender">{senderName}</span>}
                    {user?.date_time && (
                        <span className="ui-complaint-detail__date">
                            {new Date(user.date_time).toLocaleDateString("ru-RU")}
                        </span>
                    )}
                </div>
                <ComplaintStatus reviewed={user?.reviewed} />
            </div>
            <div className="ui-complaint-detail__body">
                {user?.course?.title && (
                    <div className="ui-complaint-detail__course">
                        <span className="ui-complaint-detail__label">Kurs</span>
                        <span className="ui-complaint-detail__course-title">{user?.course?.title}</span>
                    </div>
                )}
                <h3 className="ui-complaint-detail__title">{user?.title}</h3>
                <p className="ui-complaint-detail__text">{user?.description}</p>
            </div>
            <div className="ui-complaint-detail__footer">
                <Button leftIcon={<CheckCircle2 />} onClick={reviewComplaint}>Ko'rib chiqildi</Button>
            </div>
        </Card>
    );
};

export default Chat;
